import { render } from "./Index-main.vue?vue&type=template&id=0b9b2732"
import script from "./Index-main.vue?vue&type=script&lang=js"
export * from "./Index-main.vue?vue&type=script&lang=js"

import "./Index-main.vue?vue&type=style&index=0&id=0b9b2732&lang=css"
import "./Index-main.vue?vue&type=style&index=1&id=0b9b2732&lang=scss"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__